// Generation de la liste à partir 
// des options du <select>

(function ( $ ) {
    $.fn.ddContainer = function() {
        return $(this).each(function(){
            var $that = $(this),
                $ddButton = $that.find('.js-dropsel-btn'),
                $ddList = $that.find('.js-dropsel'),
                $select = $that.find('.js-select'),
                $options = $that.find('.js-select option'),

                // showlabel permet d'insérer une classe (et un style) spécifique
                // sur chacun des élément de liste à partir d'un data attribut
                // "data-class" placé sur l'option
                showLabel = $that.is('.js-dropsel-label'),
                optionZero = $that.is('.no-option-0'),
                selected,
                currentValue;

            $(this).addClass('initialized');

            $ddList.empty();

            $options.each(function(index) {
                var text = $(this).text(),
                    value = $(this).val();

                if ($(this).is(':selected')) {
                    selected = text;
                    if (showLabel) {
                        currentValue = $(this).data('class');
                    }
                }

                if (showLabel) {
                    var labelClass = $(this).data('class');
                    $ddList.append('<li tabindex="0" class="js-dropsel-item dropsel-label-'+labelClass+'" data-value="'+value+'">' + text + '</li>'); 
                } else if (optionZero) {
                    if (index != 0) {
                        $ddList.append('<li tabindex="0" class="js-dropsel-item" data-value="'+value+'">' + text + '</li>');
                    };
                } else {
                    $ddList.append('<li tabindex="0" class="js-dropsel-item" data-value="'+value+'">' + text + '</li>');
                }

            });
            $ddList.find('.js-dropsel-item').ddItem();
            $ddButton.text(selected);

            if (showLabel) {
                $ddButton.addClass("dropsel-label-"+currentValue);       
            }
        });
    };
}( jQuery ));

// Contrôle du bouton
(function ( $ ) {
    $.fn.ddButton = function() {
        return $(this).each(function(){
            var $dropsel = $(this).next();

            $(this).addClass('initialized');

            $(this).on('click', function(e){
                e.preventDefault();
                e.stopPropagation();
                keydown = 0;

                $('.js-dropsel').not($dropsel).removeClass('open');
                $(this).next().toggleClass('open');
            });
        });
    };
}( jQuery ));

// Contrôle des éléments de liste
(function ( $ ) {
    $.fn.ddItem = function() {
        return $(this).on('click', function(){
            var value = $(this).data('value'),
                $parent = $(this).parent();
                keydown = 0;

            $parent.toggleClass('open');
            $parent.prevAll('.js-select').val(value).trigger('change');
        });
    };
}( jQuery ));

// Contrôle du <select>
(function ( $ ) {
    $.fn.ddSelect = function() {
        return $(this).each(function(){
            var $that = $(this),
                showLabel = $that.parent().is('.js-dropsel-label');

            $(this).addClass('initialized');

            $that.on('change', function(){
                var value = $that.find('option:selected').val(),
                    text = $that.find('option:selected').text(),
                    classes = $that.next().attr("class").split(' ');

                $that.next().text(text);
                if (showLabel) {
                    var labelClass = $that.find('option:selected').data('class');
                    $.each(classes, function(i, c) {
                        if (c.indexOf("dropsel-label-") == 0) {
                            $that.next().removeClass(c);
                        }
                    });
                    $that.next().addClass("dropsel-label-"+labelClass);
                }
            });

            $that.on('focus', function(){
                minWidth(screenLg,function(){
                    $that.next().click();
                },function(){});
            });
        })
    };
}( jQuery ));

// Application de la classe overflow hidden
// sur le <body> lors du survol de la liste 
(function ( $ ) {
    $.fn.ddList = function() {
        return $(this).each(function(){
            $(this).addClass('initialized');
            $(this).hover(function(){
                $('.js-body').css('overflow', 'hidden');
            }, function(){
                $('.js-body').css('overflow', 'auto');
            });
        });
    };
}( jQuery ));

function initDropsels() {
    if ($('.js-dropsel-container').not('.initialized').length) {
        $('.js-dropsel-container').not('.initialized').ddContainer();
    }

    if ($('.js-dropsel-btn').not('.initialized').length) {
        $('.js-dropsel-btn').not('.initialized').ddButton();
    }

    if ($('.js-select').not('.initialized').length) {
        $('.js-select').not('.initialized').ddSelect();
    }

    if ($('.js-dropsel').not('.initialized').length) {
        $('.js-dropsel').not('.initialized').ddList();
    }    
}

$(function() {

    initDropsels();

    // Navigation au clavier
    $(document).keyup(function(e) {
        var dropOpen = $('.js-dropsel.open').length ? true : false;

        if (dropOpen) {
            if (e.keyCode == 40 || e.keyCode == 9) {
                e.preventDefault();
                e.stopPropagation();

                var num = $('.js-dropsel.open li').length;

                if (keydown < num) {
                    keydown++;
                }

                $('.js-dropsel.open li:nth-child('+ keydown +')').focus();

            } else if (e.keyCode == 38) {
                e.preventDefault();
                e.stopPropagation();

                if (keydown > 1) {
                    keydown--;
                }

                $('.js-dropsel.open li:nth-child('+ keydown +')').focus();

            } else if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();

                $('.js-dropsel.open li:nth-child('+ keydown +')').click();
            }
        }
    });

    $('.js-body').on('click', function(){
        if ($('.js-dropsel').length) {
            $('.js-dropsel').removeClass('open');
        }
    });
});